export default "__VITE_ASSET__BBQkGuy4__"